module.exports = __webpack_public_path__ + "static/media/multipop.a3416c5d.png";